import BigNumber from 'bignumber.js/bignumber'
import { BlockProvider } from './context/block';
import { NativeTokenPriceProvider } from './context/nativeTokenPrice';
import { NftProvider } from './context/nft';
import { FarmsProvider } from './context/farms';
import { PoolsProvider } from './context/pools';
import { VaultsProvider } from './context/vaults';
import { WalletProvider } from './context/wallet';
import { UxProvider } from './context/ux';
// import { TxProvider } from './context/transactions';
import { ToastProvider } from './context/toast';

import Layout from './layout/Layout';

import './i18n';

import './App.scss';

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
});

const App = () => {
  return (
    <UxProvider>
      <ToastProvider>
        <WalletProvider>
          <BlockProvider>
            <NativeTokenPriceProvider>
              <NftProvider>
                <FarmsProvider>
                  <PoolsProvider>
                    <VaultsProvider>
                      {/* <TxProvider> */}
                        <Layout/>
                      {/* </TxProvider> */}
                    </VaultsProvider>
                  </PoolsProvider>
                </FarmsProvider>
              </NftProvider>
            </NativeTokenPriceProvider>
          </BlockProvider>
        </WalletProvider>
      </ToastProvider>
    </UxProvider>
  );
}

export default App;
